export const unduhConstants = {
  UNDUH_GETALL_REQUEST: 'UNDUH_GETALL_REQUEST',
  UNDUH_GETALL_SUCCESS: 'UNDUH_GETALL_SUCCESS',
  UNDUH_GETALL_FAILURE: 'UNDUH_GETALL_FAILURE',

  UNDUH_CREATEXLS_REQUEST: 'UNDUH_CREATEXLS_REQUEST',
  UNDUH_CREATEXLS_SUCCESS: 'UNDUH_CREATEXLS_SUCCESS',
  UNDUH_CREATEXLS_FAILURE: 'UNDUH_CREATEXLS_FAILURE',
}
